<script>
import { mapGetters } from 'vuex'
export default {
    props: {
        count: 0
    },
    data() {
        return {

            desc: {
                'energy_use': window.Drupal.t("<h3>Energy use climate</h3><p>Energy use climate actions: conscious efforts made to reduce energy consumption.</p> <span>Examples: turning off lights when they are not in use, taking shorter and colder showers, and turning off devices that are not in use</span>"),
                'food_sources_and_choices': window.Drupal.t("<h3>Food Sources and Choices</h3><p>Food source and choices climate actions: responsible choices related to the food you eat and where it comes from.</p><span>Examples: Eating less meat; Shopping for food from a local farmer's market</span>"),
                'transport_and_mobility': window.Drupal.t("<h3>Transport and mobility</h3><p>Transport and mobility climate actions: conscious efforts made towards decreasing transportation emissions and using more environmentally friendly options</p><span>Examples: Walking or Biking; Using public transit; Carpooling with friends</span>"),
                'consumption_and_waste_management': window.Drupal.t("<h3>Consumption and waste management</h3><p>Consumption and waste management climate actions: the responsible handling of resources and materials in an effort to reduce the generation of waste</p><span>Examples: Recycling, donating/shopping at thrift stores, using reusable takeout containers</span>"),
                'nature_stewardship': window.Drupal.t("<h3>Nature stewardship</h3><p>Nature stewardship climate actions: the responsible appreciation, treatment, and protection of the environment</p><span>Examples: Plant trees, pick up litter, take time to appreciate nature</span>"),
                'advocacy_and_citizen_participation': window.Drupal.t("<h3>Advocacy and citizen participation</h3> <p>Advocacy and citizen participation climate actions: active involvement in community efforts to support and promote climate change initiatives</p><span>Examples: Sign and share climate advocacy petitions; Participate in citizen science initiatives that help us to understand the environment better; join or form a “green team”</span>"),
                'other_commitments': window.Drupal.t("<h3>Other commitments</h3> <p>Other: climate actions that do not fit in the 6 other categories but still play an important role in protecting the environment</p>")
            },
            locations: {
                Canada: window.Drupal.t('Canada'),
                Alberta: window.Drupal.t('Alberta'),
                'British Columbia': window.Drupal.t('British Columbia'),
                Manitoba: window.Drupal.t('Manitoba'),
                'New Brunswick': window.Drupal.t('New Brunswick'),
                'Newfoundland and Labrador': window.Drupal.t('Newfoundland and Labrador'),
                'Nova Scotia': window.Drupal.t('Nova Scotia'),
                'Northwest Territories': window.Drupal.t('Northwest Territories'),
                Nunavut: window.Drupal.t('Nunavut'),
                Ontario: window.Drupal.t('Ontario'),
                'Prince Edward Island': window.Drupal.t('Prince Edward Island'),
                Quebec: window.Drupal.t('Quebec'),
                Saskatchewan: window.Drupal.t('Saskatchewan'),
                Yukon: window.Drupal.t('Yukon')
            },
            categories: {
                'all': window.Drupal.t('Number of Youth Climate Actions Pledged'),
                'energy_use': window.Drupal.t('Energy use'),
                'food_sources_and_choices': window.Drupal.t('Food choice and source'),
                'transport_and_mobility': window.Drupal.t('Transport and mobility'),
                'consumption_and_waste_management': window.Drupal.t('Consumption and waste management'),
                'nature_stewardship': window.Drupal.t('Nature stewardship'),
                'advocacy_and_citizen_participation': window.Drupal.t('Advocacy and citizen participation'),
                'other_commitments': window.Drupal.t('Other commitments')
            },
            category: 'all',
            location: 'Canada',
            commitments: this.count,
            location_title: window.Drupal.t('Province/Territory'),
            category_title: window.Drupal.t('Action commitments categories'),
            category_all: window.Drupal.t('All Categories'),
            category_energy_use: window.Drupal.t('Energy use'),
            category_food_sources_and_choices: window.Drupal.t('Food choice and source'),
            category_transport_and_mobility: window.Drupal.t('Transport and mobility'),
            category_consumption_and_waste_management: window.Drupal.t('Consumption and waste management'),
            category_nature_stewardship: window.Drupal.t('Nature stewardship'),
            category_advocacy_and_citizen_participation: window.Drupal.t('Advocacy and citizen participation'),
            category_other_commitments: window.Drupal.t('Other commitments'),
            btn_reset: window.Drupal.t('Reset'),
        }
    },
    created() {
        this.$root.$refs.commitments = this
    },
    watch: {
        location(data) {
            this.location = data
            this.commitments = this.setCount()
        },
        category(data) {
            this.category = data
            this.commitments = this.setCount()
        }
    },
    methods: {
        setCount() {
            if (this.location === 'Canada' && this.category !== 'all') {
                return this.getCategoryTotal(this.category)
            }
            else return this.getCommitment(this.category, this.location)
        },
        updateLocation(location) {
            this.location = location
        },
        reset() {
            this.location = 'Canada';
            this.category = 'all';
        }
    },
    computed: {
        ...mapGetters({
            youthCommitments: 'getYouthCommitments',
            getCommitment: 'getCommitment',
            getCategoryTotal: 'getCategoryTotal'
        })
    },

}
</script>
<template>
    <div class="filtered-commitments">
        <div class=" wrapper views-exposed-form form--inline">
            <div
                class="js-form-item form-item js-form-type-select form-item-webform-submission-value js-form-item-webform-submission-value">
                <label class="form-item__label">{{ this.location_title }}</label>
                <select name="webform_submission_value" v-model="location"
                    class="form-select form-element form-element--type-select">
                    <option value="Canada">{{ this.locations.Canada }}</option>
                    <option value="Alberta">{{ this.locations.Alberta }}</option>
                    <option value="British Columbia">{{ this.locations['British Columbia'] }}</option>
                    <option value="Manitoba">{{ this.locations.Manitoba }}</option>
                    <option value="New Brunswick">{{ this.locations['New Brunswick'] }}</option>
                    <option value="Newfoundland and Labrador"> {{ this.locations['Newfoundland and Labrador'] }}
                    </option>
                    <option value="Nova Scotia">{{ this.locations['Nova Scotia'] }} </option>
                    <option value="Northwest Territories">{{ this.locations['Northwest Territories'] }}</option>
                    <option value="Nunavut">{{ this.locations.Nunavut }}</option>
                    <option value="Ontario">{{ this.locations.Ontario }}</option>
                    <option value="Prince Edward Island">{{
                            this.locations['Prince Edward Island']
                    }}</option>
                    <option value="Quebec">{{ this.locations.Quebec }}</option>
                    <option value="Saskatchewan">{{ this.locations.Saskatchewan }}</option>
                    <option value="Yukon">{{ this.locations.Yukon }}</option>
                </select>
            </div>
            <div
                class="js-form-item form-item js-form-type-select form-item-webform-submission-value-1 js-form-item-webform-submission-value-1">
                <label class="form-item__label">{{ this.category_title }}</label>
                <select name="webform_submission_value_1" v-model="category"
                    class="form-select form-element form-element--type-select">
                    <option value="all">{{ this.category_all }}</option>
                    <option value="energy_use">{{ this.category_energy_use }}</option>
                    <option value="food_sources_and_choices">
                        {{ this.category_food_sources_and_choices }}
                    </option>
                    <option value="transport_and_mobility">
                        {{ this.category_transport_and_mobility }}
                    </option>
                    <option value="consumption_and_waste_management">
                        {{ this.category_consumption_and_waste_management }}</option>
                    <option value="nature_stewardship">
                        {{ this.category_nature_stewardship }}</option>
                    <option value="advocacy_and_citizen_participation">
                        {{ this.category_advocacy_and_citizen_participation }}</option>
                    <option value="other_commitments">
                        {{ this.category_other_commitments }}</option>
                </select>
            </div>
            <div class="form-actions form-wrapper">
                <button v-show="(location !== 'Canada' || category != 'all')" @click="reset"
                    class="button js-form-submit form-submit">{{ this.btn_reset }}</button>
            </div>
        </div>
        <div class="table-wrapper">
            <div v-if="(category !== 'all')" class="desc">
                <article v-html="desc[category]"></article>
            </div>
            <table class="views-table cols-10">
                <thead>
                    <tr>
                        <th scope="col">{{ this.location_title }}</th>
                        <th scope="col">{{ this.categories[this.category] }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="views-field views-field-webform-submission-value is-active">{{ this.location }}
                        </td>
                        <td class="views-field views-field-webform-submission-value-1">{{ this.commitments }} </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<style scoped>
.filtered-commitments {
    display: flex;
    flex-direction: column;
    margin-top: 2rem;
}

.table-wrapper {
    display: block;
    margin-top: 2rem;
}

.desc {
    padding: 2rem;
    border-radius: 2px;
    margin: 2rem 0;
    background-color: #efefefef;
}
</style>